import { toast } from 'vue3-toastify';

import type { ISupportTicket, ISupportTicketDetail, ISupportTicketQuery } from '@/interfaces/agency/support';
import supportService from '@/services/agency/support';

export const useSupportStore = defineStore('supportStore', {
  state: () => ({
    tickets: [] as ISupportTicket[],
    total: 0,
    isLoading: false,
    currentTicket: null as ISupportTicketDetail | null,
    query: {
      page: 1,
      perPage: 30,
      orderBy: 'created_at',
      orderType: 'desc',
      status: null
    } as ISupportTicketQuery
  }),

  getters: {
    getTickets: state => state.tickets,
    getCurrentTicket: state => state.currentTicket,
    getTotal: state => state.total,
    totalPages: state => Math.ceil(state.total / state.query.perPage)
  },

  actions: {
    async fetchTickets() {
      this.isLoading = true;

      const { data } = await supportService.fetchTickets(this.query);

      this.tickets = data?.tickets || [];
      this.total = data?.total || 0;
      this.isLoading = false;
    },

    async fetchTicketById(id: number) {
      const { data } = await supportService.fetchTicketById(id);

      this.currentTicket = data || null;
    },

    async createTicket(formData: FormData) {
      const { data } = await supportService.createTicket(formData);

      toast.success(data?.message || 'Ticket submitted successfully.');
    },

    async replyToTicket(id: number, body: string, attachments: File[]) {
      const formData = new FormData();

      formData.append('body', body);
      attachments.forEach(file => formData.append('attachments[]', file));

      await supportService.replyToTicket(id, formData);
    }
  }
});
